var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.heading.Show
    ? _c(
        "app-draggable-resize-combo",
        {
          attrs: {
            x: _vm.heading.X,
            y: _vm.heading.Y,
            width: _vm.heading.Width,
            height: _vm.heading.Height,
          },
          on: {
            "update:x": function ($event) {
              return _vm.$set(_vm.heading, "X", $event)
            },
            "update:y": function ($event) {
              return _vm.$set(_vm.heading, "Y", $event)
            },
            "update:width": function ($event) {
              return _vm.$set(_vm.heading, "Width", $event)
            },
            "update:height": function ($event) {
              return _vm.$set(_vm.heading, "Height", $event)
            },
          },
        },
        _vm._l(_vm.props, function (headingNum) {
          return _c(
            "p",
            {
              key: headingNum,
              staticClass: "line",
              style: _vm.heading[headingNum].Style.getStyle(),
            },
            [
              _vm.heading[headingNum].Value == "FreeLine"
                ? _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.heading[headingNum].FreeLineText.getTranslation(
                            _vm.lang
                          )
                        ) +
                        " "
                    ),
                  ])
                : _vm.heading[headingNum].Value
                ? _c("span", [
                    _vm._v(" " + _vm._s(_vm.getText(headingNum)) + " "),
                  ])
                : _vm._e(),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }